import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import {RadioButton} from 'material-ui/RadioButton';
import VotingRadioButtonDropdownGroup from 'components/pure/search/voting/VotingRadioButtonDropdownGroup';
import VotingRadioButtonsSearchFieldActions from 'actions/search/VotingRadioButtonsSearchFieldActions';

/** Constant to keep track of each radio button in the whole group */
const SELECTED_VOTING_RADIO_BUTTON = {
  anybody: {value: 'anybody', label: 'Anybody'},
  team: {value: 'team', label: 'Member of Team'},
  department: {value: 'department', label: 'Member of Department'},
};

/**
 * Render the inner-nested voting radio button UI groups for "Who rated:"
 * - Anybody
 * - Member of team
 * - Member of department
 */
export default class VotingRadioButtonsGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked && !this.props.checked) {
      this.setState({selectedRadioButton: null});
    }
  }

  onChangeGroupButton = (event, value) => {
    if (value === SELECTED_VOTING_RADIO_BUTTON.anybody.value) {
      this.props.onChangeSecondLevelValue(SELECTED_VOTING_RADIO_BUTTON.anybody);
    }
    VotingRadioButtonsSearchFieldActions.removeCurrentVotingValue();
    setTimeout(() => this.setState({selectedRadioButton: value}), 0);
  };

  /** Render a group of radio buttons for `Anybody, Member of Team, Member of Department` */
  render() {
    const radioButtonStyle = {fontSize: '0.8em'};
    return (
      <div>
        <Checkbox
          onCheck={this.props.onCheck}
          data-key={this.props.dataKey}
          style={this.props.style}
          label={this.props.label}
          checked={this.props.checked}
        />
        {this.props.checked ? (
          <div>
            <RadioButton
              {...SELECTED_VOTING_RADIO_BUTTON.anybody}
              style={radioButtonStyle}
              checked={
                this.state.selectedRadioButton === SELECTED_VOTING_RADIO_BUTTON.anybody.value
              }
              onCheck={this.onChangeGroupButton}
              data-key={SELECTED_VOTING_RADIO_BUTTON.anybody.value}
            />
            <VotingRadioButtonDropdownGroup
              {...SELECTED_VOTING_RADIO_BUTTON.team}
              dataKey={SELECTED_VOTING_RADIO_BUTTON.team.value}
              store={this.props.store}
              style={radioButtonStyle}
              onChangeGroupButton={this.onChangeGroupButton}
              checked={this.state.selectedRadioButton === SELECTED_VOTING_RADIO_BUTTON.team.value}
            />
            <VotingRadioButtonDropdownGroup
              {...SELECTED_VOTING_RADIO_BUTTON.department}
              dataKey={SELECTED_VOTING_RADIO_BUTTON.department.value}
              store={this.props.store}
              style={radioButtonStyle}
              onChangeGroupButton={this.onChangeGroupButton}
              checked={
                this.state.selectedRadioButton === SELECTED_VOTING_RADIO_BUTTON.department.value
              }
            />
          </div>
        ) : null}
      </div>
    );
  }
}
